module.exports = __webpack_public_path__ + "img/preimush-img-2.e2da04c8.png";